export enum EApiCallStateNames {}

export enum EApiRequestPartKeys {}
